"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.assign");

var _colors = require("@material-ui/core/colors");

var primary = Object.assign({}, _colors.lightBlue, {
  contrastText: _colors.common.white,
  dark: _colors.lightBlue[900],
  light: _colors.lightBlue[600],
  main: _colors.lightBlue[800]
});
var _default = primary;
exports["default"] = _default;